import { render, staticRenderFns } from "./TournamentRegistrationForm.vue?vue&type=template&id=11f874fa&scoped=true"
import script from "./TournamentRegistrationForm.vue?vue&type=script&lang=js"
export * from "./TournamentRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./TournamentRegistrationForm.vue?vue&type=style&index=0&id=11f874fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f874fa",
  null
  
)

export default component.exports